import { gql } from 'graphql-request'

export const ATUALIZAR_GRUPO_FAVORITO = gql`
  mutation AtualizarGrupoFavorito($id: ID!) {
    atualizarGrupoFavorito(id: $id) {
      id
      nome
      favorito
    }
  }
`
